import React, { useEffect, useRef, useState } from "react";
import JoditEditor from "jodit-react";
import { BsUpload } from "react-icons/bs";
import { useFirebase } from "../../Context/FirebaseContext";
import { CircularProgress } from "@mui/material";

const BlogForm = ({
  handleChange,
  handleCheckbox,
  setContent,
  content,
  categories,
  setFeaturedImage,
}) => {
  const editor = useRef(null);
  const firebase = useFirebase();
  const [imageLabel, setImageLabel] = useState(
    "Upload featured image for post"
  );
  const [url, setUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const isImageFile = (file) => {
    return file && file.type.startsWith("image/");
  };

  const handleImageUpload = async (file) => {
    setIsLoading(true);
    const url = await firebase.handleImageUpload(file);
    setFeaturedImage(url);
    if (url) {
      firebase.getImageUrl(url).then((url) => {
        setUrl(url);
        setIsLoading(false);
      });
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (isImageFile(file)) {
      setImageLabel(
        file
          ? file.name.substring(0, 10) + "..." + file.name.split(".")[1]
          : "Upload featured image for post"
      );
      handleImageUpload(file);
    } else {
      setImageLabel("Please choose a valid image file");
    }
  };

  return (
    <>
      <div className="dark:text-white">
        <div className="flex justify-between items-center flex-wrap-reverse gap-6">
          <div className="flex items-center gap-4 flex-wrap">
            {url && (
              <div className="relative h-40">
                {isLoading ? (
                  <div className="animate-pulse bg-gray-300 dark:bg-gray-700 rounded h-40 w-full"></div>
                ) : (
                  <label htmlFor="featuredImage">
                    <img
                      className="object-cover rounded h-full w-full"
                      alt="featured"
                      src={url}
                    />
                  </label>
                )}
              </div>
            )}
            <BsUpload className="text-2xl" />
            <label
              htmlFor="featuredImage"
              className="cursor-pointer inline-block"
            >
              {imageLabel}
              <input
                type="file"
                className="hidden"
                name="featuredImage"
                id="featuredImage"
                onChange={handleFileChange}
              />
            </label>
          </div>

          <button
            type="submit"
            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            disabled={isLoading}
          >
            {isLoading && (
              <CircularProgress color="inherit" size={20} thickness={5} />
            )}
            {!isLoading && "Publish"}
          </button>
        </div>
        <div className="w-full my-4">
          <textarea
            type="text"
            name="title"
            id="title"
            placeholder="Add Title"
            className="w-full resize-none sm:text-[4rem] border-none py-2 px-2 outline-none dark:text-white text-[2rem] bg-transparent"
            onChange={handleChange}
            required
          />
        </div>
        <div className="my-14">
          <JoditEditor
            ref={editor}
            value={content}
            tabIndex={1}
            onBlur={(newContent) => setContent(newContent)}
            onChange={(newContent) => {
              setContent(newContent);
            }}
          />
        </div>
        <div className="mb-8">
          <p className="text-xl font-bold">Choose Category</p>
          <div className="mt-4 grid grid-cols-2 sm:grid-cols-3 gap-2">
            {categories.map((c) => (
              <div className="flex items-start" key={c._id}>
                <div className="flex items-center h-5">
                  <input
                    id={c.name}
                    name={c.name}
                    type="checkbox"
                    className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                    onChange={handleCheckbox}
                  />
                </div>
                <div className="ml-3 text-sm">
                  <label
                    htmlFor={c.name}
                    className="font-medium text-gray-700 dark:text-white"
                  >
                    {c.name}
                  </label>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogForm;
